module.exports = __webpack_public_path__ + "static/media/statistics.9754ade5.svg";